export function isAccountantsPage() {
  return window.location.pathname.includes('/accountants/');
}

